// eslint-disable-next-line import/prefer-default-export
export const PtoActionOnRejection = Object.freeze({
    Submitted : 0,
    Refused: 1,
    Cancelled: 2,
});
